export default Object.freeze({
  dark: 'dark',
  light: 'light',
  inverted: 'inverted',
})
